"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryNewCardForm = BasisTheoryNewCardForm;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _elements = require("@reservamos/elements");
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _BtSaveCardCheckbox = require("@/components/purchase/BtSaveCardCheckbox");
var _useBasisTheoryElements = require("@/hooks/libs/useBasisTheoryElements");
var _useBasisTheorySubmit = require("@/hooks/purchase/payments/basisTheory/useBasisTheorySubmit");
var _useCanSaveAuthenticatedCard = require("@/hooks/store/useCanSaveAuthenticatedCard");
var _BasisTheoryCardFields = require("./BasisTheoryCardFields");
var _BasisTheoryCheckoutSkeleton = require("./BasisTheoryCheckoutSkeleton");
var _PrivacyNotice = require("./PrivacyNotice");
var _savedCards = require("@/metrics/user-analytics/savedCards");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Render and submit the secure fields for a new Basis Theory card. */
function BasisTheoryNewCardForm(_ref) {
  var active = _ref.active,
    cardErrorOccured = _ref.cardErrorOccured,
    _ref$embedded = _ref.embedded,
    embedded = _ref$embedded === void 0 ? false : _ref$embedded,
    monthlySelectedPlan = _ref.monthlySelectedPlan,
    onCardDetailsChange = _ref.onCardDetailsChange,
    hasSavedCards = _ref.hasSavedCards,
    publicKey = _ref.publicKey;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)(['payment', 'purchase']),
    t = _useTranslation.t;
  var purchaseToken = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.get('token');
  });
  var currency = (0, _reactRedux.useSelector)(function (state) {
    return state.whitelabelConfig.env.currency;
  });
  var canSaveCard = (0, _useCanSaveAuthenticatedCard.useCanSaveAuthenticatedCard)();
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    holderName = _useState2[0],
    setHolderName = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    saveCard = _useState4[0],
    setSaveCard = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    cardBrand = _useState6[0],
    setCardBrand = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    retryKey = _useState8[0],
    setRetryKey = _useState8[1];
  var placeholders = {
    cardNumber: t('purchase:label.bt_form.card_number_placeholder'),
    expiration: t('purchase:label.bt_form.expiration_placeholder'),
    cvc: t('purchase:label.bt_form.cvv_placeholder')
  };
  var ariaLabels = {
    cardNumber: t('purchase:label.bt_form.card_number_label'),
    expiration: t('purchase:label.bt_form.expiration_label'),
    cvc: t('purchase:label.bt_form.cvv_label')
  };
  var _useBasisTheoryElemen = (0, _useBasisTheoryElements.useBasisTheoryElements)({
      ariaLabels: ariaLabels,
      publicKey: publicKey,
      placeholders: placeholders,
      onCardBrandChange: setCardBrand,
      onCardDetailsChange: onCardDetailsChange,
      retryKey: retryKey
    }),
    clientRef = _useBasisTheoryElemen.clientRef,
    elementsRef = _useBasisTheoryElemen.elementsRef,
    isComplete = _useBasisTheoryElemen.isComplete,
    mountedRef = _useBasisTheoryElemen.mountedRef,
    status = _useBasisTheoryElemen.status;
  var isSubmitting = (0, _useBasisTheorySubmit.useBasisTheorySubmit)({
    active: active,
    canSaveCard: canSaveCard,
    cardBrand: cardBrand,
    clientRef: clientRef,
    currency: currency,
    dispatch: dispatch,
    elementsRef: elementsRef,
    holderName: holderName,
    isComplete: isComplete,
    mountedRef: mountedRef,
    monthlySelectedPlan: monthlySelectedPlan,
    purchaseToken: purchaseToken,
    saveCard: saveCard,
    status: status
  });
  var shellClassName = embedded ? 'relative' : 'relative mt-5 rounded-[14px] border border-gray-200 bg-white p-[14px] shadow-[0_4px_18px_rgba(15,23,42,0.08)]';
  function retryAfterMountError() {
    setHolderName('');
    setSaveCard(false);
    setCardBrand('');
    onCardDetailsChange({
      bin: '',
      brand: '',
      expirationComplete: false,
      last4: ''
    });
    setRetryKey(function (currentKey) {
      return currentKey + 1;
    });
  }
  function handleSaveCardChange(enabled) {
    (0, _savedCards.trackSaveCardCheckboxClicked)(enabled, hasSavedCards);
    setSaveCard(enabled);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: shellClassName,
    "aria-busy": status === 'loading' || isSubmitting,
    "data-sentry-component": "BasisTheoryNewCardForm",
    "data-sentry-source-file": "BasisTheoryNewCardForm.tsx"
  }, status === 'loading' && /*#__PURE__*/_react["default"].createElement(_BasisTheoryCheckoutSkeleton.BasisTheoryCheckoutSkeleton, {
    embedded: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: status === 'loading' ? 'pointer-events-none absolute inset-0 opacity-0' : ''
  }, /*#__PURE__*/_react["default"].createElement(_elements.Spacing, {
    vertical: true,
    "data-sentry-element": "Spacing",
    "data-sentry-source-file": "BasisTheoryNewCardForm.tsx"
  }, status === 'error' && /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
    title: t('purchase:label.problems_paying'),
    borderColor: "warning"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-start gap-3"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S"
  }, t('purchase:text.suggestions_to_payment_problems')), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "cursor-pointer border-0 bg-transparent p-0 text-sm font-semibold text-accent-regular underline",
    onClick: retryAfterMountError
  }, t('payment:button.try_the_pay_again')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-3 px-5 pb-4 pt-6 md:gap-[14px] ".concat(status === 'ready' ? 'visible' : 'invisible')
  }, /*#__PURE__*/_react["default"].createElement(_BasisTheoryCardFields.BasisTheoryCardFields, {
    holderName: holderName,
    onHolderNameChange: function onHolderNameChange(event) {
      return setHolderName(event.target.value);
    },
    t: t,
    "data-sentry-element": "BasisTheoryCardFields",
    "data-sentry-source-file": "BasisTheoryNewCardForm.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_BtSaveCardCheckbox.BtSaveCardCheckbox, {
    available: canSaveCard,
    checked: saveCard,
    label: t('purchase:label.bt_form.save_card_toggle'),
    onChange: handleSaveCardChange,
    "data-sentry-element": "BtSaveCardCheckbox",
    "data-sentry-source-file": "BasisTheoryNewCardForm.tsx"
  }), /*#__PURE__*/_react["default"].createElement(_PrivacyNotice.PrivacyNotice, {
    available: canSaveCard,
    "data-sentry-element": "PrivacyNotice",
    "data-sentry-source-file": "BasisTheoryNewCardForm.tsx"
  })), cardErrorOccured && /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
    title: t('purchase:label.problems_paying'),
    borderColor: "warning"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S"
  }, t('purchase:text.suggestions_to_payment_problems'))))));
}